import pDebounce from "p-debounce";

import { env } from "@src/env";

import { getTimestampInSeconds } from "@src/utils/getTimestampInSeconds";

function ping(
  url: string,
  onSuccess: () => void,
  onError: () => void,
  timeoutMs: number,
) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    controller.abort("TIMEOUT");
  }, timeoutMs);

  fetch(url, {
    signal: controller.signal,
    method: "HEAD",
    redirect: "follow",
    mode: "no-cors",
  })
    .then(onSuccess)
    .catch(onError)
    .finally(() => {
      clearTimeout(timeoutId);
    });
}

const DEFAULT_TIMEOUT_MS = 5_000;

export function checkConnection(
  onlineCallback: () => void,
  offlineCallback: () => void,
  timeoutMs = DEFAULT_TIMEOUT_MS,
) {
  const cacheBuster = getTimestampInSeconds();
  // Plano A
  ping(
    `https://clients3.google.com/generate_204?_=${cacheBuster}`,
    onlineCallback,
    () => {
      // Plano B
      ping(
        `${env.api}/frontend-version?cache_buster=${cacheBuster}`,
        onlineCallback,
        offlineCallback,
        timeoutMs,
      );
    },
    timeoutMs,
  );
}

const _isConnected = pDebounce(
  (timeoutMs: number): Promise<boolean> =>
    new Promise((resolve) => {
      checkConnection(
        () => resolve(true), // onlineCallback
        () => resolve(false), // offlineCallback
        timeoutMs,
      );
    }),
  DEFAULT_TIMEOUT_MS,
  { before: true },
);

export function isConnected(timeoutMs = DEFAULT_TIMEOUT_MS): ReturnType<typeof _isConnected> {
  return _isConnected(timeoutMs);
}
